"use strict";

exports.__esModule = true;
exports.getKey = exports.MultiAggregateSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _excluded = ["items", "tags", "selected", "onSelect", "getClickedItem", "label", "placeholderLabel"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getKey = exports.getKey = function getKey(item) {
  return item.name;
};
function getGroupItem(groups, filteredItems, renderItem, onSelect, selected) {
  if (selected === void 0) {
    selected = [];
  }
  return function (groupKey) {
    var group = groups[groupKey];
    var groupItems = filteredItems.filter(group);
    if (groupItems.length <= 1) {
      return null;
    }
    var itemNames = groupItems.map(function (i) {
      return i.name;
    });
    var isSelected = selected.find(function (item) {
      return itemNames.includes(item.name);
    });
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: "GROUP:" + groupKey,
      "data-testid": "data-test:" + groupKey,
      text: groupItems[0].groupLabel,
      shouldDismissPopover: false,
      icon: /*#__PURE__*/_react["default"].createElement("span", {
        className: _core.Classes.CONTROL_INDICATOR
      }, isSelected ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: _icons.IconNames.SMALL_TICK
      }) : /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: _icons.IconNames.BLANK
      })),
      popoverProps: {
        usePortal: true
      }
    }, /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxListContainer, null, groupItems.map(function (item) {
      return renderItem(item, {
        handleClick: function handleClick() {
          return onSelect(item);
        }
      });
    })));
  };
}
function getRenderList(groups, onSelect, focusList, selected) {
  return function (_ref) {
    var filteredItems = _ref.filteredItems,
      items = _ref.items,
      itemsParentRef = _ref.itemsParentRef,
      renderItem = _ref.renderItem;
    var groupedMenuItems;
    if (groups != null) {
      groupedMenuItems = Object.keys(groups).map(getGroupItem(groups, filteredItems, renderItem, onSelect, selected));
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxListContainer, {
      "data-testid": "DropdownCheckboxListContainer",
      ref: focusList
    }, filteredItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_core.Menu, {
      ulRef: itemsParentRef
    }, groupedMenuItems, filteredItems.filter(function (i) {
      return items.filter(function (item) {
        return item.groupId === i.groupId;
      }).length === 1;
    }).map(function (item) {
      return renderItem(item, {
        handleClick: function handleClick() {
          return onSelect(item);
        }
      });
    })));
  };
}
var MultiAggregateSelector = exports.MultiAggregateSelector = function MultiAggregateSelector(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var focusList = _react["default"].useRef(null);
  var _useState = (0, _react.useState)(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var defaultLabel = translate("MultiAggregateSelector.placeholder.multiple", "Select Aggregates");
  var items = props.items,
    tags = props.tags,
    selected = props.selected,
    onSelect = props.onSelect,
    getClickedItem = props.getClickedItem,
    _props$label = props.label,
    label = _props$label === void 0 ? defaultLabel : _props$label,
    _props$placeholderLab = props.placeholderLabel,
    placeholderLabel = _props$placeholderLab === void 0 ? defaultLabel : _props$placeholderLab,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var onInteraction = function onInteraction() {
    if (focusList.current != null && focusList.current !== document.activeElement) {
      // the input is no longer focused so we can close the popover
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  var groups = tags.reduce(function (groups, tag) {
    groups[tag] = function (item) {
      return item.groupId === tag;
    };
    return groups;
  }, {});
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: label
  }, /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxList, _extends({
    style: {
      maxWidth: "200px"
    },
    isOpen: isOpen,
    onInteraction: onInteraction,
    groups: groups,
    selected: selected,
    items: items,
    renderItemText: function renderItemText(item) {
      return item.label;
    },
    renderList: getRenderList(groups, onSelect, focusList, selected),
    getKey: getKey,
    onSelect: onSelect,
    icon: _icons.IconNames.BOX,
    placeholder: placeholderLabel,
    getClickedItem: getClickedItem
  }, extra)));
};